export class Permission {
  enableOffPlanGrid = false;
  dealManagement: string[];
}
